import apiClient from './ApiInterceptor';

export const getConversations= async (filters = {}) => {
    const params = new URLSearchParams(
      Object.fromEntries(Object.entries(filters).filter(([, v]) => v))
    ).toString();
    const response = await apiClient.get(`/crm?${params}`);
    return response;
};

export const getMessages= async (id) => {
    const response = await apiClient.get(`/crm/${id}/messages`);
    return response;
};

export const getMetrics= async () => {
    const response = await apiClient.get(`/crm/metrics`);
    return response;
};

export const sendMessage= async (id, formatedText) => {
    const params = {
        text: formatedText
    }
    const response = await apiClient.post(`/crm/${id}/messages`, params);
    return response;
};

export const updateState= async (id, newState) => {
    const params = {
        new_state: newState
    }
    const response = await apiClient.patch(`/crm/${id}/state`, params);
    return response;
};

export const reprocessMessage = async (messageId) => {
    const response = await apiClient.post(`/crm/reprocess/${messageId}`);
    return response;
};

export const markConversationRead = async (id) => {
    const response = await apiClient.post(`/crm/${id}/read`);
    return response;
};

export const markConversationUnread = async (id) => {
    const response = await apiClient.delete(`/crm/${id}/read`);
    return response;
};

export const sendFeedback = async (payload) => {
    const response = await apiClient.post('/feedback', payload);
    return response;
};

export const forceFeedbackImprovement = async (payload) => {
    const response = await apiClient.post('/feedback/force', payload);
    return response;
};

export const fetchRagEntries = async (status = 'PENDING', limit = 50, offset = 0) => {
    const response = await apiClient.get('/rag', { params: { status, limit, offset } });
    return response;
};

export const updateRagEntry = async (id, payload) => {
    const response = await apiClient.patch(`/rag/${id}`, payload);
    return response;
};
